import React, { FC } from 'react'

import { DecorationTitle } from 'src/components/atoms'
import {
  CommonContentSelectLayoutItem,
  CommonContentLayoutType,
  CommonContentLayoutKeys,
} from 'src/components/molecules'
import { CommonContentReleaseSetting } from 'src/components/organisms'

import {
  useCommonContentPage,
  useCommonContentPageLoading,
  useGetCommonContentPages,
  useToast,
  useAuthority,
} from 'src/hooks'
import { CommonContentPageEntity } from 'src/types'

type Props = {
  commonContent: CommonContentPageEntity
  className?: string
}

export const CommonContentSelectLayout: FC<Props> = ({ commonContent, className }) => {
  const { toCommonContentPageFormEntity, updateCommonContentPage } = useCommonContentPage()
  const { refetch } = useGetCommonContentPages()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()
  const { showCommonContentPageLoading, hideCommonContentPageLoading } =
    useCommonContentPageLoading()
  const { canWriteCommonContent } = useAuthority()

  const handleOnClick = async (updatedFormat: CommonContentLayoutType) => {
    showCommonContentPageLoading()

    const formEntity = toCommonContentPageFormEntity(commonContent)
    const updatedFormEntity = { ...formEntity, designFormat: updatedFormat }

    try {
      await updateCommonContentPage({
        commonContentPageId: commonContent.id,
        formEntity: updatedFormEntity,
      })
      refetch()
      displayStandardTextToast('保存しました')
    } catch {
      displayErrorTextToast('保存に失敗しました')
    } finally {
      hideCommonContentPageLoading()
    }
  }

  return (
    <div className={className}>
      <div className="tw-flex tw-justify-between">
        <DecorationTitle>表示レイアウト選択</DecorationTitle>
        <CommonContentReleaseSetting commonContent={commonContent} />
      </div>

      <div className="tw-flex tw-gap-s2 tw-mt-s2">
        {CommonContentLayoutKeys.map(key => (
          <CommonContentSelectLayoutItem
            key={key}
            isSelected={key === commonContent.designFormat}
            layoutType={key}
            onClick={handleOnClick}
            canEdit={canWriteCommonContent}
          />
        ))}
      </div>
    </div>
  )
}
